const defaultService = {}

function uuidv4() {
    try {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    } catch (e) {
        return "uid-" + Date.now() + "-" + Math.random().toString(36).slice(2);
    }
}


var ACKREQUESTS = []
var LISTENERS = []

function onMessage(payload) {
    try {
        const type = payload.type
        const session = payload.session

        if (session) {
            var ackIndex = ACKREQUESTS.findIndex(i => i.session == session)
            if (ackIndex !== -1) {
                try {
                    ACKREQUESTS[ackIndex].callback(payload)
                } catch (e) {
                    console.error("ACK callback failed", e)
                }
                ACKREQUESTS.splice(ackIndex, 1)
            }
        } else {
            for (var listener of LISTENERS) {
                if (listener.type == type) {
                    try {
                        listener.callback(payload)
                    } catch (e) {
                        console.error("Listener callback failed", type, e)
                    }
                }
            }
        }
    } catch (e) {
        console.error("onMessage failed", e)
    }
}


function sendMessage(payload) {
    if (!window.ReactNativeWebView || !window.ReactNativeWebView.postMessage) {
        console.error("Unable to communicate with native app", payload?.type)
        return false
    }

    try {
        window.ReactNativeWebView.postMessage(JSON.stringify(payload))
        return true
    } catch (e) {
        console.error("postMessage failed", e)
        return false
    }
}

function sendWithACK(type, params) {
    const session = uuidv4()

    const payload = {type: type, session: session, data: params}

    return new Promise((resolve, reject) => {
        let timeout = setTimeout(() => {
            const idx = ACKREQUESTS.findIndex(i => i.session === session)
            if (idx !== -1) ACKREQUESTS.splice(idx, 1)
            reject({success: false, error: "SESSION TIMEOUT"})
        }, 60 * 1000)

        ACKREQUESTS.push({
            session: session, callback: (result) => {
                clearTimeout(timeout)
                const data = result.data
                resolve(data)
            }
        })

        if (!sendMessage(payload)) {
            clearTimeout(timeout)
            const idx = ACKREQUESTS.findIndex(i => i.session === session)
            if (idx !== -1) ACKREQUESTS.splice(idx, 1)
            reject({success: false, error: "SEND ERROR"})
        }
    })
}


defaultService.sendMessage = sendMessage

defaultService.init = () => {
    if (window.ISWEB) {
        return true
    }

    if (window.ISAPP) {

        window.addEventListener("message", function (event) {
            try {
                onMessage(JSON.parse(event.data));
            } catch (e) {
                // Ignore non-JSON messages from third parties
            }
        });


        document.addEventListener("message", function (event) {
            try {
                onMessage(JSON.parse(event.data));
            } catch (e) {
                // Ignore non-JSON messages from third parties
            }
        });

        sendMessage({type: "init", data: {}})

        return true
    }

    console.error("Unable to connect with app bridge")
    // Avoid hard reload loop — the native side will reload the WebView on real errors
    return false
}


defaultService.addEventListener = function (type, callback) {

    const id = uuidv4()

    const remove = () => {
        const index = LISTENERS.findIndex(i => i.id == id)
        if (index === -1) {
            console.warn("Listener already removed", id, type)
            return
        }
        LISTENERS.splice(index, 1)
    }

    LISTENERS.push({
        id: id,
        type: type,
        callback: callback
    })

    return remove
}


defaultService.get = async function (type, params = {}) {

    try {
        return await sendWithACK(type, params)
    } catch (error) {
        console.error("AppService.get error", type, error)
        return error
    }

}

export default defaultService
